import { toAppUrl } from '../utils';
import logo from '@/assets/img/experian-logo.png';
import verticalDivider from '@/assets/img/vertical-bar.png';
import { ReactNode } from 'react';
import {
  Flex,
  Link,
  Text,
  Image,
  HStack,
  StackDivider,
} from '@chakra-ui/react';
import { LOGIN_TYPE_ENUM } from '@ssar-app/domain';

interface LightLogoProps {
  title?: ReactNode;
  isInternalLogin?: boolean;
  loginType?: string;
}

export const LightLogo = (props: LightLogoProps) => {
  const { title, loginType } = props;
  return (
    <Flex alignItems='center' h={16} justifyContent='space-between'>
      <Link
        href={toAppUrl('/')}
        outline='none'
        w='36'
        _focus={{ boxShadow: 'none' }}
      >
        <Image src={logo} w='100%' alt='Experian' />
      </Link>
      {title && (
        <>
          <Image w='0.5' opacity='0.5' src={verticalDivider} alt='' mx={4} />
          <Text
            mb={0}
            fontWeight='bold'
            fontSize='md'
            fontFamily='Barlow'
            color={'blue.700'}
          >
            Ascend Access
          </Text>
        </>
      )}
      {!title && (
        <HStack divider={<StackDivider />} h={10}>
          <Link
            href={toAppUrl(
              loginType === LOGIN_TYPE_ENUM.CLIENT
                ? '/login/okta-gdc'
                : '/login',
            )}
            outline='none'
            w='28'
            _focus={{ boxShadow: 'none' }}
            color={'blue.600'}
          >
            {loginType === LOGIN_TYPE_ENUM.CLIENT
              ? 'Go to GDC Login'
              : 'Go to Client Login'}
          </Link>
          <Link
            href={toAppUrl(
              loginType === LOGIN_TYPE_ENUM.INTERNAL
                ? '/login/okta-gdc'
                : '/login/internal',
            )}
            outline='none'
            w='28'
            _focus={{ boxShadow: 'none' }}
            color={'blue.600'}
          >
            {loginType === LOGIN_TYPE_ENUM.INTERNAL
              ? 'Go to GDC Login'
              : 'Go to Internal Login'}
          </Link>
        </HStack>
      )}
    </Flex>
  );
};
